import { useEffect, useState } from 'react'

const locale = 'en-GB' // GB here to get the format of DD/MM/YYYY

const formatDate = (date) => {
  return date
    ? new Date(date).toLocaleDateString(locale).replace(/\//g, '-')
    : ''
}

export default formatDate

export const TARGET_DATE = '08/27/2023'
export const getDateTimerValues = (
  targetDate = new Date(TARGET_DATE),
  currentDate = new Date(),
) => {
  // get total seconds between the times
  let delta = Math.abs(targetDate - currentDate) / 1000

  // calculate (and subtract) whole days
  const days = Math.floor(delta / 86400)
  delta -= days * 86400

  // calculate (and subtract) whole hours
  const hours = Math.floor(delta / 3600) % 24
  delta -= hours * 3600

  // calculate (and subtract) whole minutes
  const minutes = Math.floor(delta / 60) % 60
  delta -= minutes * 60

  // what's left is seconds (without the milliseconds)
  const seconds = Math.trunc(delta % 60) // in theory the modulus is not required

  return { days, hours, minutes, seconds }
}

export const useTimerValues = (targetDate = TARGET_DATE) => {
  const [countDown, setCountDown] = useState({
    targetDate: new Date(targetDate),
    currentDate: new Date(),
  })
  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown({
        targetDate: new Date(targetDate),
        currentDate: new Date(),
      })
    }, 1000)

    return () => clearInterval(interval)
  }, [targetDate])

  return getDateTimerValues(countDown.targetDate, countDown.currentDate)
}
